import React from 'react'

const RequestTemplate = props => {

  const {httpMethod, url, authorizationHeader, body} = props;

  return (
    <div>
      <h3>Request</h3>
      <div>
        <h5 className="long-words">
          <span className="label label-active label-normal-white-space">{httpMethod}</span>
          {url}
        </h5>
      </div>
      <div>
        <div className="hpanel">
          <div className="panel-heading">
            <div className="row vertical-align">
              <div className="col-xs-12"><span>Headers</span></div>
            </div>
          </div>
          <div className="panel-body">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <span>
                    Content-Type:
                  </span>
                  <span className="margin-left-15">
                    <strong>application/json</strong>
                  </span>
                </div>
                <div className="clearfix">
                  <span>
                    Authorization:
                  </span>
                  <span className="margin-left-15">
                    <strong className="long-words">
                      {authorizationHeader}
                    </strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <pre>{JSON.stringify(body, null, 2)}</pre>
      </div>
    </div>
  );
};

export default RequestTemplate;



// WEBPACK FOOTER //
// ./src/common/RequestTemplate.js